var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.83337C9.03837 2.83337 6.02087 5.85087 6.02087 9.56254C6.02087 13.2034 8.86837 16.15 12.58 16.2775C12.6934 16.2634 12.8067 16.2634 12.8917 16.2775C12.92 16.2775 12.9342 16.2775 12.9625 16.2775C12.9767 16.2775 12.9767 16.2775 12.9909 16.2775C16.6175 16.15 19.465 13.2034 19.4792 9.56254C19.4792 5.85087 16.4617 2.83337 12.75 2.83337Z",
    fill: "url(#paint0_linear_363_8781)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9466 20.0458C15.9941 17.4108 9.54828 17.4108 5.56744 20.0458C3.76828 21.25 2.77661 22.8792 2.77661 24.6217C2.77661 26.3642 3.76828 27.9792 5.55328 29.1692C7.53661 30.5008 10.1433 31.1667 12.7499 31.1667C15.3566 31.1667 17.9633 30.5008 19.9466 29.1692C21.7316 27.965 22.7233 26.35 22.7233 24.5933C22.7091 22.8508 21.7316 21.2358 19.9466 20.0458Z",
    fill: "url(#paint1_linear_363_8781)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3191 10.3984C28.5458 13.1467 26.5908 15.5551 23.885 15.8809C23.8708 15.8809 23.8708 15.8809 23.8566 15.8809H23.8141C23.7291 15.8809 23.6441 15.8809 23.5733 15.9092C22.1991 15.9801 20.9383 15.5409 19.9891 14.7334C21.4483 13.4301 22.2841 11.4751 22.1141 9.35006C22.015 8.20256 21.6183 7.15423 21.0233 6.26173C21.5616 5.99256 22.185 5.82256 22.8225 5.76589C25.5991 5.52506 28.0783 7.59339 28.3191 10.3984Z",
    fill: "url(#paint2_linear_363_8781)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1525 23.5025C31.0392 24.8767 30.1609 26.0667 28.6875 26.8742C27.2709 27.6533 25.4859 28.0217 23.715 27.9792C24.735 27.0583 25.33 25.9108 25.4434 24.6925C25.585 22.9358 24.7492 21.25 23.0775 19.9042C22.1284 19.1533 21.0234 18.5583 19.8192 18.1192C22.95 17.2125 26.8884 17.8217 29.3109 19.7767C30.6142 20.825 31.28 22.1425 31.1525 23.5025Z",
    fill: "url(#paint3_linear_363_8781)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_363_8781",
    x1: 12.75,
    y1: 2.83337,
    x2: 12.75,
    y2: 16.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_363_8781",
    x1: 12.7499,
    y1: 18.0696,
    x2: 12.7499,
    y2: 31.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_363_8781",
    x1: 24.1631,
    y1: 5.74683,
    x2: 24.1631,
    y2: 15.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_363_8781",
    x1: 25.4936,
    y1: 17.7078,
    x2: 25.4936,
    y2: 27.9825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUsers);
export default __webpack_public_path__ + "static/media/multi-users.fe172e33c489c967361ac45e8d256d3a.svg";
export { ForwardRef as ReactComponent };